export const useUserProfileController = () => {
  const userStore = useUserStore();
  const { $serverApi } = useNuxtApp();
  const getUserAvailableProfilePictures = async () => {
    const profilePictures = await $serverApi<GFALResponse<string[]>>(
      "/api/users/self/profile-picture/available",
      {
        headers: constructHeaders(userStore.authToken),
      }
    ).catch((error) => {
      console.error("error", error);
      return error;
    });
    return (profilePictures.payload || []).slice(1);
  };

  const updateUserProfilePicture = async (profilePicture: string) => {
    const response = await $serverApi<GFALResponse<Purchase>>(
      `/api/users/self/profile-picture`,
      {
        method: "PUT",
        headers: constructHeaders(userStore.authToken),
        body: {
          profilePicture: profilePicture,
        },
      }
    );
    if (response.statusCode === 200)
      userStore.profilePicture = profilePicture.toUpperCase();
    return response;
  };

  const getUserAvailableProfileBanners = async () => {
    const profileBanners = await $serverApi<GFALResponse<string[]>>(
      "/api/users/self/profile-banner/available",
      {
        headers: constructHeaders(userStore.authToken),
      }
    ).catch((error) => {
      console.error("error", error);
      return error;
    });
    return (profileBanners.payload || []).slice(1);
  };

  const updateUserProfileBanner = async (profileBanner: string) => {
    const response = await $serverApi<GFALResponse<Purchase>>(
      `/api/users/self/profile-banner`,
      {
        method: "PUT",
        headers: constructHeaders(userStore.authToken),
        body: {
          profileBanner: profileBanner,
        },
      }
    );
    if (response.statusCode === 200) userStore.profileBanner = profileBanner;
    return response;
  };

  return {
    getUserAvailableProfilePictures,
    updateUserProfilePicture,
    getUserAvailableProfileBanners,
    updateUserProfileBanner,
  };
};
